<div class="atlas-table" *ngIf="displayCustomFields">
  <p-table [showGridlines]="true" [value]="eComItemTypeCustomFieldItemValues">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>
          {{ 'common.name' | translate | ucfirst }}
        </th>
        <th>
          {{ 'common.description' | translate | ucfirst }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-customfielditemvalue>
      <tr>
        <td>{{ customfielditemvalue.CustomFieldName }}</td>
        <td>
          <input
            pInputText
            name="value"
            class="form-control"
            [(ngModel)]="customfielditemvalue.Value"
            (change)="changeCustomFieldValues()"
          />
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>
